import getConfig from "next/config";

const { publicRuntimeConfig } = getConfig();

/**
 * Cleans a URL path by removing specified tracking/non-canonical parameters
 * based on the CANONICAL_EXCLUDED_PARAMS runtime config
 * 
 * @param asPath - The URL path with query parameters from Next.js router
 * @returns Clean path suitable for canonical URLs
 */
export const cleanExcludedParams = (asPath: string): string => {
    const [pathname, queryString] = asPath.split('?');
    const { CANONICAL_EXCLUDED_PARAMS } = publicRuntimeConfig;
    if (!queryString) return pathname;

    // Get excluded parameters from runtime config (comma-separated)
    const excludedParamsEnv = CANONICAL_EXCLUDED_PARAMS as string;

    // Parse excluded parameters from runtime config (comma-separated)
    let excludedParams: string[] = [];


    if (excludedParamsEnv) {
        excludedParams = excludedParamsEnv
            .split(',')
            .map(param => param.trim().toLowerCase())
            .filter(param => param.length > 0);
    }

    const params = new URLSearchParams(queryString);
    const cleanParams = new URLSearchParams();

    // Keep only parameters that are not in the excluded list
    params.forEach((value, key) => {
        if (!excludedParams.includes(key.toLowerCase())) {
            cleanParams.append(key, value);
        }
    });

    const cleanQuery = cleanParams.toString();
    return cleanQuery ? `${pathname}?${cleanQuery}` : pathname;
}; 